var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"lyric"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],style:({ bottom: _vm.distance}),attrs:{"id":"default_drag_return"},on:{"click":function($event){$event.stopPropagation();return _vm.topreturn.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }